import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { useSavingsStore } from '@/store/useSavingsStore'
import { useUserStore } from '@/store/useUserStore'
import { useGetWallet, type WalletCurrency } from '@/domain'

export const ResetTransferOutOnRouteEntry: React.FC = () => {
  const location = useLocation()
  const setGoalTransferOut = useSavingsStore(
    (state) => state.setGoalTransferOut,
  )
  const wallet = useUserStore((s) => s.wallet)
  const displayCurrency = wallet?.displayCurrency || 'USD'
  const completeCurrencies = useUserStore((s) => s.wallet?.completeCurrencies)

  // Находим USDT в кошельке пользователя для получения актуального кода валюты
  const usdtWallet = completeCurrencies?.find(
    (currency: WalletCurrency) => currency.code === 'USDT',
  )

  useEffect(() => {
    // Проверяем, что мы находимся на странице transfer-out
    if (location.pathname.includes('/savings/transfer-out')) {
      // Сбрасываем суммы при входе на страницу transfer-out
      setGoalTransferOut({
        cryptoAmount: {
          amount: '0',
          code: usdtWallet?.code || 'USDT',
        },
        fiatAmount: {
          amount: '0',
          code: displayCurrency,
        },
        triggerShake: false,
        isFiatMode: false, // В отличие от first-deposit, начинаем в crypto режиме (как в RN)
      })
    }
  }, [location.pathname, setGoalTransferOut, displayCurrency, usdtWallet?.code])

  return null
}
